export default __webpack_public_path__ + "static/media/questionsInformationIcon.343bc402.svg";